import { Card, CardBody } from "reactstrap";
import FilterHeader from "../../Common/FilterHeader";
import SubHeader from "../../Common/SubHeader";
import TransactionTable from "./TransactionTable";
import {useMemo} from 'react'

export const BANKS = [
  { value: "", label: "All Banks" },
  { value: "Sterling Bank", label: "Sterling Bank" },
  { value: "Keystone Bank", label: "Keystone Bank" },
  { value: "FCMB", label: "FCMB" },
  { value: "Diamond Bank", label: "Diamond Bank" },
  { value: "United Bank for Africa", label: "United Bank for Africa" },
  { value: "JAIZ Bank", label: "JAIZ Bank" },
  { value: "Fidelity Bank", label: "Fidelity Bank" },
  { value: "Polaris Bank", label: "Polaris Bank" },
  { value: "Citi Bank", label: "Citi Bank" },
  { value: "Ecobank Bank", label: "Ecobank Bank" },
  { value: "Unity Bank", label: "Unity Bank" },
  { value: "StanbicIBTC Bank", label: "StanbicIBTC Bank" },
  { value: "GTBank Plc", label: "GTBank Plc" },
  { value: "Access Bank", label: "Access Bank" },
  { value: "First Bank of Nigeria", label: "First Bank of Nigeria" },
  { value: "Wema Bank", label: "Wema Bank" },
  { value: "Union Bank", label: "Union Bank" },
  { value: "Enterprise Bank", label: "Enterprise Bank" },
  { value: "Zenith Bank Plc", label: "Zenith Bank Plc" },
  { value: "Heritage", label: "Heritage" },
  { value: "StandardChartered", label: "StandardChartered" },
  { value: "Suntrust Bank", label: "Suntrust Bank" },
  { value: "Providus Bank", label: "Providus Bank" },
  { value: "Rand Merchant Bank", label: "Rand Merchant Bank" },
  { value: "Titan Trust Bank", label: "Titan Trust Bank" },
  { value: "Taj Bank", label: "Taj Bank" },
  { value: "Globus Bank", label: "Globus Bank" },
  { value: "Central Bank of Nigeria", label: "Central Bank of Nigeria" },
  { value: "Premium Trust Bank", label: "Premium Trust Bank" },
  { value: "Coronation Merchant Bank", label: "Coronation Merchant Bank" },
  { value: "FBNQUEST Merchant Bank", label: "FBNQUEST Merchant Bank" },
  { value: "Nova Merchant Bank", label: "Nova Merchant Bank" },
  { value: "Greenwich Merchant Bank", label: "Greenwich Merchant Bank" },
  { value: "FSDH Merchant Bank", label: "FSDH Merchant Bank" },
  { value: "NPF MicroFinance Bank", label: "NPF MicroFinance Bank" },
  { value: "Fortis Microfinance Bank", label: "Fortis Microfinance Bank" },
  { value: "Covenant MFB", label: "Covenant MFB" },
  { value: "Page Financials", label: "Page Financials" },
  { value: "Kuda Microfinance Bank", label: "Kuda Microfinance Bank" },
  { value: "VFD MFB", label: "VFD MFB" },
  { value: "Sparkle", label: "Sparkle" },
  { value: "Eyowo", label: "Eyowo" },
  { value: "RenMoney Microfinance Bank", label: "RenMoney Microfinance Bank" },
  { value: "Accion Microfinance Bank", label: "Accion Microfinance Bank" },
  { value: "Lapo Microfinance Bank", label: "Lapo Microfinance Bank" },
  { value: "NIRSAL Microfinance Bank", label: "NIRSAL Microfinance Bank" },
  { value: "AB Microfinance Bank", label: "AB Microfinance Bank" },
  { value: "Grooming Microfinance Bank", label: "Grooming Microfinance Bank" },
  { value: "Safe Haven Microfinance Bank", label: "Safe Haven Microfinance Bank" },
  { value: "Advans La Fayette Microfinance Bank", label: "Advans La Fayette Microfinance Bank" },
  { value: "Addosser Microfinance Bank", label: "Addosser Microfinance Bank" },
  { value: "Mainstreet Microfinance Bank", label: "Mainstreet Microfinance Bank" },
  { value: "Bosak Microfinance Bank", label: "Bosak Microfinance Bank" },
  { value: "Amju Unique Microfinance Bank", label: "Amju Unique Microfinance Bank" },
  { value: "Mutual Benefits Microfinance Bank", label: "Mutual Benefits Microfinance Bank" },
  { value: "FCT Microfinance Bank", label: "FCT Microfinance Bank" },
  { value: "Purplemoney Microfinance Bank", label: "Purplemoney Microfinance Bank" },
  { value: "EdFin Microfinance Bank", label: "EdFin Microfinance Bank" },
  { value: "MayFair Microfinance Bank", label: "MayFair Microfinance Bank" },
  { value: "Rephidim Microfinance Bank", label: "Rephidim Microfinance Bank" },
  { value: "Mainland Microfinance Bank", label: "Mainland Microfinance Bank" },
  { value: "Legend Microfinance Bank", label: "Legend Microfinance Bank" },
  { value: "Seedvest Microfinance Bank", label: "Seedvest Microfinance Bank" },
  { value: "Corestep Microfinance Bank", label: "Corestep Microfinance Bank" },
  { value: "Headway Microfinance Bank", label: "Headway Microfinance Bank" },
  { value: "Pillar Microfinance Bank", label: "Pillar Microfinance Bank" },
  { value: "Bridgeway Microfinance Bank", label: "Bridgeway Microfinance Bank" },
  { value: "Amac Microfinance Bank", label: "Amac Microfinance Bank" },
  { value: "UNAAB Microfinance Bank", label: "UNAAB Microfinance Bank" },
  { value: "Evergreen Microfinance Bank", label: "Evergreen Microfinance Bank" },
  { value: "CashConnect Microfinance Bank", label: "CashConnect Microfinance Bank" },
  { value: "Waya Microfinance Bank", label: "Waya Microfinance Bank" },
  { value: "Paga", label: "Paga" },
  { value: "Paycom(Opay)", label: "Paycom(Opay)" },
  { value: "PalmPay Limited", label: "PalmPay Limited" },
  { value: "Flutterwave Technology Solutions Limited", label: "Flutterwave Technology Solutions Limited" },
  { value: "Paystack Payment Limited", label: "Paystack Payment Limited" },
  { value: "Interswitch Limited", label: "Interswitch Limited" },
  { value: "Teamapt Limited", label: "Teamapt Limited" },
  { value: "9Payment Service Bank", label: "9Payment Service Bank" },
  { value: "HopePSB", label: "HopePSB" },
  { value: "MoMo PSB", label: "MoMo PSB" },
  { value: "SmartCash PSB", label: "SmartCash PSB" },
  { value: "One Finance", label: "One Finance" },
  { value: "Crowdforce", label: "Crowdforce" },
  { value: "NIP Virtual Bank", label: "NIP Virtual Bank" },
  { value: "Accelerex Network Limited", label: "Accelerex Network Limited" },
  { value: "Gateway Mortgage Bank", label: "Gateway Mortgage Bank" },
  { value: "Abbey Mortgage Bank", label: "Abbey Mortgage Bank" },
  { value: "Refuge Mortgage Bank", label: "Refuge Mortgage Bank" },
  { value: "Platinum Mortgage Bank", label: "Platinum Mortgage Bank" },
  { value: "First Generation Mortgage Bank", label: "First Generation Mortgage Bank" },
  { value: "Lagos Building Investment Company", label: "Lagos Building Investment Company" },
  { value: "Brent Mortgage Bank", label: "Brent Mortgage Bank" },
  { value: "Infinity Trust Mortgage Bank", label: "Infinity Trust Mortgage Bank" },
  { value: "MayFresh Mortgage Bank", label: "MayFresh Mortgage Bank" },
  { value: "Imperial Homes Mortgage Bank", label: "Imperial Homes Mortgage Bank" },
  { value: "AG Mortgage Bank", label: "AG Mortgage Bank" },
  { value: "FBN Mortgages Limited", label: "FBN Mortgages Limited" },
  { value: "Jubilee-Life Mortgage Bank", label: "Jubilee-Life Mortgage Bank" },
  { value: "Trustbond Mortgage Bank", label: "Trustbond Mortgage Bank" },
  { value: "SafeTrust", label: "SafeTrust" },
];

const fields = [
  { key: "firstName", label: "First Name", type: "text", placeholder: "John" },
  { key: "lastName", label: "Last Name", type: "text", placeholder: "Doe" },
  { key: "userId", label: "User ID", type: "text", placeholder: "4000000000" },
  { key: "bankName", label: "Bank Name", type: "select", options: BANKS },
  { key: "bankAccountNumber", label: "Account Number", type: "text", maxLength: 10, placeholder: "4000123456" },
  { key: "createdAt", label: "Date Range", type: "daterange", colClass: "col-12 col-md-4 col-lg-2" },
];

const Transactions = ({
  data,
  isLoading,
  totalRows,
  currentPage,
  onSearch,
  onPageChange,
  onReset,
  activeFilters,
  limit,
  onRefresh
  
}) => {
  const handleSearch = (currentFilters) => {
    const payload = {
      firstName: currentFilters.firstName,
      lastName: currentFilters.lastName,
      userId: currentFilters.userId,
      bankName: currentFilters.bankName,
      bankAccountNumber: currentFilters.bankAccountNumber,
      dateFrom: currentFilters.createdAtFrom,
      dateTo: currentFilters.createdAtTo,
    };
    onSearch(payload);
  };

  // Map flat filters back to key names expected by FilterHeader (handling DateRange suffixes)
  const mappedInitialFilters = useMemo(() => ({
  ...activeFilters,
  createdAtFrom: activeFilters?.dateFrom,
  createdAtTo: activeFilters?.dateTo,
}), [activeFilters]);
const shouldShowSearch = totalRows > 0 || Object.values(activeFilters).some((v) => !!v);
  return (
    <>
      <SubHeader title="Bank Deposits" data={data} />

      {shouldShowSearch && (
        <FilterHeader
          title="Filter Records"
          fields={fields}
          onSearch={handleSearch}
          isLoading={isLoading} 
          onReset={onReset}
          initialFilters={mappedInitialFilters}
          onRefresh={onRefresh} 
        />
      )}

      <Card className="tranaction-card">
        <CardBody className="pt-4">
          <div className="table-responsive recent-table transaction-table">
            <TransactionTable
              data={data}
              isLoading={isLoading}
              totalRows={totalRows}
              currentPage={currentPage}
              onPageChange={onPageChange}
              limit={limit}
            />
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default Transactions;